import { createToaster } from "@meforma/vue-toaster";
import "../assets/toast.css";

const toaster = createToaster({
    position: 'top-right',
    duration: 6000
});

export { toaster }
